import { CSS, Spacing, StyleProps } from "@shared/primitive-components"

export const marginBottom =
  (margin: Spacing) =>
  (props: StyleProps): CSS => ({
    marginBottom: props.theme.spacing(margin),
  })

export const paddingLeft =
  (margin: Spacing) =>
  (props: StyleProps): CSS => ({
    paddingLeft: props.theme.spacing(margin),
  })

export const tooltipContent = (): CSS => ({
  maxWidth: `200px`,
})

export const fullWidth = (): CSS => ({
  width: `100%`,
})

export const speedingOverTimeContainer = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(4),
  minHeight: `437px`,
})

export const speedingHeading = (props: StyleProps): CSS => ({
  textTransform: `uppercase`,
  fontSize: props.theme.fontSize.body,
  marginBottom: props.theme.spacing(3),
})

export const speedingOverview = (): CSS => ({
  maxWidth: `259px`,
})

export const speedingDate = (props: StyleProps): CSS => ({
  ...props.theme.fonts.subHeading,
  fontSize: props.theme.fontSize.caption,
  marginBottom: props.theme.spacing(6),
})

export const speedingPercentage = (props: StyleProps): CSS => ({
  fontSize: props.theme.fontSize.large,
  marginBottom: props.theme.spacing(2),
})

export const speedingLabel = (props: StyleProps): CSS => ({
  lineHeight: 1.25,
  marginBottom: props.theme.spacing(6),
})
